import { render, staticRenderFns } from "./Retornos.vue?vue&type=template&id=437053b0"
import script from "./Retornos.vue?vue&type=script&lang=js"
export * from "./Retornos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports